import React from 'react'
import { TextField } from '@material-ui/core/'
import { useField } from 'formik'

export default function NameField({ label, ...props }) {
	const [field, meta] = useField(props)
	const errorText = meta.error && meta.touched ? meta.error : ''

	return (
		<TextField
			{...field}
			label={label}
			id={label}
			variant='outlined'
			required
			error={!!errorText}
			helperText={errorText}
		/>
	)
}
